/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */
import './AllowCookiesInterceptor.js';
import './MaintenanceModeInterceptor.js';
import './tokeninterceptor.js';
import './UnauthorizedInterceptor';
import './ExpiredOrgErrorInterceptor.js';

/**
 * Grouping module used for including all interceptor sub-modules.
 */
angular
  .module('sbsf.interceptors', [
    'interceptor.cookie',
    'interceptor.maintenance',
    'interceptor.token',
    'interceptor.unauthorized',
    'interceptor.expiredOrgError'
  ])
  .config(function ($httpProvider) {
    // Add interceptors to the $httpProvider.
    $httpProvider.interceptors.push('allowCookiesInterceptor');
    $httpProvider.interceptors.push('tokenInterceptor');
    $httpProvider.interceptors.push('maintenanceModeInterceptor');
    $httpProvider.interceptors.push('unauthorizedInterceptor');
    $httpProvider.interceptors.push('expiredOrgErrorInterceptor');
  });
